import { useMutation, useQuery } from "@tanstack/react-query"
import { authApiEndpoints } from "@/app/config/apiEndpoints"
import { requestAuth } from "@/shared/utils/axios"

export function useFetchOneIdUrl() {
  return useQuery({
    queryKey: ["sso-auth-url"],
    queryFn: () => requestAuth.get<{ authorization_url: string }>(authApiEndpoints.oneId.getRedirectUrl).then(res => res.data),
    placeholderData: previousData => previousData
  })
}

export const useAuthWithOneIdCode = () => {
  return useMutation({
    mutationFn: async (code: string | null) => {
      const response = requestAuth.post(authApiEndpoints.oneId.authenticate, { code })
      if ((await response).status === 404) {
        throw new Error("Not Found")
      }
      return (await response).data
    }
  })
}
